import { APIBase, Fetcher } from "nate-react-api-helpers";

export class SubAPI {
    fetcher: Fetcher;

    constructor(parent: APIBase) {
        this.fetcher = parent.fetcher;
    }
}
